import Cookies from 'js-cookie';

import { localStorageNames } from '@shared/constants/local-storage-names';

export const getCredentials = () => {
  const refreshToken = Cookies.get(localStorageNames.refreshToken);

  return { refreshToken };
};
